import React from 'react';

import partnerLogo from 'asset/nvidia_logo_white.png';
import companyLogo from 'asset/SoftServe-logo.svg';
import cn from 'classnames';
import { motion, useCycle } from 'framer-motion';
import { Link } from 'react-scroll';

import { useCheckMobile } from '../../hooks';
import { nav_items } from './content';
import { MobileNavigation } from './MobileNavigation';

export default function Header() {
  const isNavigationHidden = useCheckMobile({ width: 1024 });
  const [isOpen, toggleOpen] = useCycle(false, true);
  return (
    <header className="fixed z-[1991] w-full border-b border-gray-900 bg-black">
      <div className="gl-wrapper box-content 1300:box-border">
        <div className="flex min-h-11 w-full max-w-[75.5rem] items-center justify-between gap-8 bg-black">
          <div className="flex w-full items-center gap-[1.125rem] 1300:flex-col 1300:items-start 1300:gap-2 lg:flex-row lg:items-center lg:gap-[1.125rem] md:flex-col md:items-start md:gap-2">
            <div className="flex items-center">
              <a className="flex items-center" target="_blank" href="https://softserveinc.com" rel="noreferrer">
                <img
                  width={116}
                  height={20}
                  src={companyLogo}
                  alt="SoftServe logo"
                  className="h-[1.25rem] min-w-[7.25rem] border-r border-white pr-[1.125rem]"
                />
              </a>
              <img
                width={114}
                height={30}
                alt="NVIDIA logo"
                className="-mt-0.5 ml-[1.125rem] w-[7.125rem]"
                src={partnerLogo}
              />
            </div>
            <span className="flex h-[1.25rem] items-center border-l border-white pl-[1.125rem] font-OpenSans text-[1.4375rem] font-bold leading-[0.69] text-white 1300:border-transparent 1300:pl-0 lg:border-l lg:!border-white lg:pl-[1.125rem] md:!border-transparent md:pl-0">
              shopping assistant
            </span>
          </div>
          {isNavigationHidden ? (
            <motion.div initial={false} animate={isOpen ? 'open' : 'closed'}>
              <MobileNavigation items={nav_items} toggle={() => toggleOpen()} />
            </motion.div>
          ) : (
            <nav className="w-full lg:hidden">
              <ul className="flex items-center justify-end gap-5 font-Proxima font-black text-white 1300:gap-3">
                {nav_items.map(({ id, title, anchor }, idx) => (
                  <li className="" key={id}>
                    <Link
                      className={cn(
                        'cursor-pointer border border-transparent px-[1rem] py-[0.375rem] font-Proxima text-[1rem] uppercase text-gray-700 transition-all duration-300 hover:border-b-[#17C583] hover:text-white',
                        idx === nav_items.length - 1 &&
                          'relative z-[3] overflow-visible bg-black !text-white before:absolute before:left-[-2px] before:top-[-2px] before:-z-[2] before:block before:h-[calc(100%+4px)] before:w-[calc(100%+4px)] before:bg-gradient-to-br before:from-[#12E999] before:to-[#BB19F4] hover:bg-gradient-to-br hover:from-[#12E999] hover:to-[#BB19F4] hover:before:!bg-none',
                      )}
                      activeClass={cn(
                        'active bg-gradient-to-b !text-white from-[#0092A8] to-[#17C583]',
                        idx === nav_items.length - 1 && 'bg-gradient-to-br from-[#12E999] to-[#BB19F4]',
                      )}
                      to={anchor}
                      spy={true}
                      smooth={true}
                      offset={0}
                      duration={500}
                    >
                      {title}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
}
